import useAuth from "./useAuth";
import { axiosPrivateInstance } from "../axios";
import { useRecoilState } from "recoil";
import { AlertState } from "states";

export default function useLogout() {
  const { setUser, setAccessToken, setCSRFToken, setStatusAuth } = useAuth();
  const [alert, setAlert] = useRecoilState(AlertState);
  const logout = async () => {
    try {
      const response = await axiosPrivateInstance.post("logout");
      setStatusAuth("logout");
      setAccessToken(null);
      setCSRFToken(null);
      setUser({});
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setAlert({
          alert: true,
          message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
          type: "error",
        });
      } else {
        console.log(error);
      }
    }
  };

  return logout;
}
